module.exports = __webpack_public_path__ + "img/DE01844.bea7a042.png";